import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';
import { ModalContextProvider } from '~settings/components/Modal';

import { RequestSublabelPage } from './pages/RequestSublabelPage';

export function SublabelRequestRouter() {
  const [containerSettingsSublabelRequest] = useFeatureFlags([
    FEATURE_FLAGS.ContainerSettingsSublabelRequest,
  ]);

  return (
    <Routes>
      {containerSettingsSublabelRequest ? (
        <Route
          path="create"
          element={
            <ModalContextProvider>
              <RequestSublabelPage />
            </ModalContextProvider>
          }
        />
      ) : null}

      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
}
SublabelRequestRouter.displayName = 'SublabelRequestRouter';
